"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var constants_1 = require("./constants");
var plugins_1 = require("../plugins");
var utils_1 = require("../utils");
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var browser_tracker_1 = require("@snowplow/browser-tracker");
/**
 * Creates a new Snowplow Tracker
 *
 * @param params all required and optional params for the Tracker initialization
 */
var snowplowTracker = function snowplowTracker(params) {
  var enabledPlugins = (0, plugins_1.getEnabledPlugins)(params.pluginConfiguration);
  var trackerConfig = Object.assign(Object.assign({}, (0, lodash_merge_1["default"])(constants_1.DEFAULT_TRACKER_CONFIG, params.trackerConfiguration)), {
    plugins: (0, plugins_1.getInitializedPlugins)(enabledPlugins)
  });
  var tracker = (0, browser_tracker_1.newTracker)(constants_1.SNOWPLOW_TRACKER_NAME, params.collectorUrl, Object.assign({
    appId: params.appId
  }, trackerConfig));
  if (typeof window !== 'undefined' && window.snowplow === undefined && tracker !== null && tracker !== undefined) {
    window.snowplow = tracker;
    (0, utils_1.dispatchSnowplowTrackerReadyEvent)();
  } else {
    (0, utils_1.dispatchSnowplowTrackerNotReadyEvent)();
  }
  (0, plugins_1.enablePlugins)(enabledPlugins);
  (0, utils_1.setGlobalContexts)(params.builtInGlobalContextProperties, params.globalContextConfiguration);
  return tracker;
};
exports["default"] = snowplowTracker;